import { FC, RefObject } from 'react';
import { useTranslation } from 'react-i18next';

import PrintButton from 'modules/_shared/components/Buttons/PrintButton';
import PrintHeader from 'modules/_shared/components/Headers/PrintHeader';
import { formatNumberDecimals } from 'utils/formats';

import { useBeneficiarySellModal } from '../context/BeneficiarySellModalContext';
import BeneficiaryDataView from './BeneficiaryDataView';
import SimulationView from './SimulationView';

type ConditionsViewProps = {
  printRef: RefObject<HTMLDivElement>;
};

const ConditionsView: FC<ConditionsViewProps> = ({ printRef }) => {
  const { t } = useTranslation();
  const { data } = useBeneficiarySellModal();

  return (
    <header>
      <PrintButton
        fileName="incentive-value-simulator"
        printRef={printRef ? (printRef as RefObject<HTMLDivElement>) : null}
        hideLabel
        className="border-0 bg-transparent text-primary btn-trigger p-1 position-absolute absolute-top-right mr-5 mt-4"
      />
      <PrintHeader title={t('PrintHeaderIncentiveValueSimulator')} />

      <div className="invoice-head d-print-block">
        <BeneficiaryDataView />

        <SimulationView />
      </div>

      <div className="invoice-head mt-2">
        <div className="invoice-contact col-12 col-md-4">
          <span className="overline-title">{t('LastSocietyValuation')}</span>
          <div className="invoice-contact-info mt-2">
            <ul className="list-plain d-flex flex-column">
              <li className="d-inline-flex">
                <em className="icon ni ni-growth" />
                <span>{formatNumberDecimals(data.societyValue) || '-'}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};

export default ConditionsView;
